import React from "react";

import { ROLES } from "../../utils/constants";
import { shortDateTime } from "../../utils/DateHelper";

const CommentCard = ({ commentData, alignRight, backgroundColor }) => {
    return (
        <>
            <div
                className={`flex flex-wrap sm:flex-nowrap border-2 border-red rounded-lg p-3 ${
                    backgroundColor || alignRight
                        ? "bg-dark-grey"
                        : "bg-light-grey"
                } min-w-min md:max-w-xl lg:max-w-3xl xl:max-w-4xl ${
                    alignRight && "ml-auto "
                } my-3`}
            >
                <div className="noshrink ml-auto mr-auto sm:ml-0 sm:mr-0">
                    <img
                        src={
                            commentData?.createdBy?.image ||
                            require("../../assets/images/no-avatar.png").default
                        }
                        className="user-img-noshrink"
                    />
                </div>
                <div className="flex flex-col text-center w-full">
                    <div className="flex flex-col sm:flex-row sm:items-center mb-2">
                        <span className="pl-3"></span>
                        <h3 className="text-sm">
                            {commentData?.createdBy?.role === ROLES.support
                                ? ROLES.support
                                : `${commentData?.createdBy?.firstname} ${commentData?.createdBy?.lastname}`}
                        </h3>
                        <p className="ml-0 sm:ml-2 text-xs text-primary-orange">
                            NeoSpectra
                        </p>
                    </div>
                    <div className="text-justify text-xs pl-3 max-w-3xl">
                        {commentData.comment}
                    </div>
                </div>
                <div className="ml-auto text-xs mt-2 sm:mt-0">
                    {shortDateTime(commentData.createdAt)}
                </div>
            </div>
        </>
    );
};

export default CommentCard;
